var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.364 1.264a.9.9 0 0 1 1.272 0l4.5 4.5a.9.9 0 0 1-1.272 1.272L10.9 4.073V12.7a.9.9 0 0 1-1.8 0V4.073L6.136 7.036a.9.9 0 0 1-1.272-1.272z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.4 11.8a.9.9 0 0 1 .9.9 2.7 2.7 0 0 0 5.4 0 .9.9 0 0 1 .9-.9H16c.274 0 .51 0 .722.033a2.7 2.7 0 0 1 2.245 2.245c.033.212.033.448.033.722v.134c0 .43 0 .748-.044 1.03a3.6 3.6 0 0 1-2.993 2.992c-.281.044-.6.044-1.029.044H5.066c-.43 0-.748 0-1.03-.044a3.6 3.6 0 0 1-2.992-2.993C1 15.682 1 15.363 1 14.934V14.8c0-.274 0-.51.033-.722a2.7 2.7 0 0 1 2.245-2.245c.212-.033.448-.033.722-.033z"
  })));
};
export default SvgUpload;